import React from 'react';
import { Badge, BadgeTypeProp } from '@qga/roo-ui/components';

const promoIcons = {
  'classic reward': 'ribbon',
  'flyer deal': 'flightRight',
  'member deal': 'roo',
};

interface PromotionalSashProps {
  promotionName: string;
  type?: BadgeTypeProp;
}

const PromotionalSash = ({ promotionName, type = 'default' }: PromotionalSashProps) => {
  const iconName = promoIcons[promotionName?.toLowerCase()];
  const isLuxuryOffer = promotionName.toLowerCase().includes('luxury');

  return (
    <>
      {!isLuxuryOffer && (
        <Badge
          text={promotionName}
          iconName={iconName}
          size="rg"
          color="white"
          fontWeight="bold"
          type={type}
          borderRadius="newPromoSash"
          backgroundColor={'brand.primary'}
        />
      )}
      {isLuxuryOffer && (
        <Badge
          text={promotionName}
          iconName={iconName}
          size="rg"
          color="white"
          backgroundColor={'greys.charcoal'}
          fontWeight="bold"
          type={type}
          borderRadius="newPromoSash"
        />
      )}
    </>
  );
};

export default PromotionalSash;
